/* eslint-disable no-shadow */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { setLocale } from '../../actions/intl';
import { setRuntimeVariable } from '../../actions/runtime';

function getIcon (lang){
  if (lang == 'en-EN') return 'https://cdn.countryflags.com/thumbs/united-kingdom/flag-round-250.png';
  if (lang == 'pl-PL') return 'https://cdn.countryflags.com/thumbs/poland/flag-round-250.png';
  if (lang == 'de-DE') return 'https://cdn1.iconfinder.com/data/icons/rounded-flat-country-flag-collection-1/2000/de-01.png';
  return 'https://cdn.countryflags.com/thumbs/poland/flag-round-250.png';
}

function LanguageSwitcher({ currentLocale, availableLocales, setLocale }) {
  const isSelected = (locale) => locale === currentLocale;
  const localeDict = {
    'en-EN': 'English',
    'pl-PL': 'Polski',
    'de-DE': 'Deutsch',
  };
  const localeName = (locale) => localeDict[locale] || locale;
  return (
    <div >
      {availableLocales.map(locale => (
        <span className="push-right" key={locale} style={{padding: '10px 30px', backgroundColor: 'white', float: 'right'}}>
          {isSelected(locale) ? (
            <span><img src={getIcon(locale)} style={{width: '15px', height: '15px'}} alt="Locale Icon" /> {localeName(locale)}</span>
          ) : (
            // github.com/yannickcr/eslint-plugin-react/issues/945
            // eslint-disable-next-line react/jsx-indent
            <a
              href={`?lang=${locale}`}
              onClick={(e) => {
                setLocale({locale});
                e.preventDefault();
              }}
            ><img src={getIcon(locale)} style={{width: '15px', height: '15px'}} alt="Locale Icon"/> {localeName(locale)}</a>
          )}
          {' '}
        </span>
      ))}
    </div>
  );
}

LanguageSwitcher.propTypes = {
  currentLocale: PropTypes.string.isRequired,
  availableLocales: PropTypes.arrayOf(PropTypes.string).isRequired,
  setLocale: PropTypes.func.isRequired,
};

const mapState = (state) => ({
  availableLocales: state.runtime.availableLocales,
  currentLocale: state.intl.locale,
});

const mapDispatch = {
  setLocale,
};

export default connect(mapState, mapDispatch)(LanguageSwitcher);



// WEBPACK FOOTER //
// src/components/LanguageSwitcher/LanguageSwitcher.js